

function updateContent(index) {
  var activeText = document.getElementsByClassName('tabs-2col__tab-content-text--active')[0];
  activeText.classList.remove("tabs-2col__tab-content-text--active");

  //var nextText = document.getElementsByClassName('tabs-2col__tab-content-' + index)[0];
  //nextText.classList.add("tabs-2col__tab-content-text--active");

  var nextText = document.getElementById('tabs-2col__tab-content-' + index);
  nextText.classList.add("tabs-2col__tab-content-text--active");
}

export default function tabs2Col() {


  var select = document.querySelectorAll('.tabs-2col select');

  if (select.length) {
    select[0].addEventListener('change', function(e) {
      //console.log('select', this.value)

      var activeTab = document.getElementsByClassName('tabs-2col__tabs--active')[0];
      if (activeTab) {
        activeTab.classList.remove("tabs-2col__tabs--active");
      }

      updateContent(this.value);
    });
  }

  var links = document.querySelectorAll('.tabs-2col__tabs a');

  links.forEach(el => {
		el.addEventListener('click', function(event) {

      event.preventDefault();

      // update tabs
      var activeTab = document.getElementsByClassName('tabs-2col__tabs--active')[0];
      if (activeTab) {
        activeTab.classList.remove("tabs-2col__tabs--active");
      }

      this.classList.add("tabs-2col__tabs--active");

      // update content
      updateContent(el.dataset.tab);

		});
	});


}
